module.exports = __webpack_public_path__ + "static/media/purush_image.3d1e0716.png";